import { render, staticRenderFns } from "./FooterMini.vue?vue&type=template&id=351406c6&scoped=true"
import script from "./FooterMini.vue?vue&type=script&lang=js"
export * from "./FooterMini.vue?vue&type=script&lang=js"
import style0 from "./FooterMini.vue?vue&type=style&index=0&id=351406c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351406c6",
  null
  
)

export default component.exports